import { Media } from '@eiq/files/models';

import { HasConditions } from './has-conditions.model';

export class QuestionOption extends HasConditions {
  id: string;
  exclusiveInd: boolean;
  pinnedPositionInd: boolean;
  value: string;
  text: string;
  stimulus: Media;
}
